import React, { useCallback, useEffect, useRef, useState } from "react";
import Joyride, { EVENTS, Step, TooltipRenderProps } from "react-joyride";
import styles from './fixDataWizard.module.scss';
import ReactDataGrid from "@inovua/reactdatagrid-community";
import Button from "../../../../components/button/Button";
import { adminEmailChecking, emailChecking, nameChecking, typoCheckingDataToClean } from "./bulkUsersImportTable";
import { isNotEmail } from "../../../../utils/validation";
import { logger } from '../../../../utils/logger';

type Props = {
  updateTableDataField: (value: any, rowId: number, columnId: string) => void,
  bulkUpdateAdminField: (value: any, rowId: number, columnId: string) => void,
  setTourEnd: (value: boolean) => void,
  dataToClean: typoCheckingDataToClean,
  dataSource: any
}

let lastElement = "";

// auto scroll method
const scrollToView = (target: string | undefined) => {
  if (target) setTimeout(() => {
    let tableEle = document.getElementById("bulkInviteTable");
    if (lastElement.substring(0, 5) !== target.substring(0, 5) && tableEle) {
      tableEle.scrollTop = 0;
    }
    let y = tableEle?.getBoundingClientRect();
    let y2 = document.getElementsByClassName(`${target.substring(1)}`)[0]?.getBoundingClientRect();
    if (y && y2) {
      let yDif = y2.y - y.y;
      tableEle?.scrollBy(0, yDif);
    }
    lastElement = target;
  }, 100);
}

const AdminEmailValidation = (props: { stepIndex: number, element: adminEmailChecking, updateTableDataField: any, bulkUpdateAdminField: any, setJoyDex: any, hello: any, skipStepToStep: (stepIndex: number) => number }) => {
  const {stepIndex, element, updateTableDataField, bulkUpdateAdminField, setJoyDex, hello, skipStepToStep} = props;
  const [selected, setSelected] = useState('');
  const [listOfAdmins, setListOfAdmins] = useState<any[]>([]);
  const [dataSor, setDataSor] = useState<any[]>([]);

  useEffect(() => {
    if (dataSor.length === 0 && listOfAdmins.length > 0) {
      setDataSor(listOfAdmins.map((admin) => {
        let ret: { id: string, admin: string } = {
          id: admin.id,
          admin: admin.name
        }
        return ret
      }));
    }
  }, [listOfAdmins, dataSor.length]);

  const selectChange = useCallback(({selected}) => {
    setSelected(selected);
  }, []);

  useEffect(() => {
    if (element?.otherData) {
      setListOfAdmins(element.otherData);
    }
  }, [element, listOfAdmins]);

  useEffect(() => {
    if (selected === '' && listOfAdmins.length > 0) {
      setSelected(listOfAdmins[0].name);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listOfAdmins])

  return <div style={{textAlign: "left"}} key={element.rowId}>
    <div style={{marginBottom: 10}}>{stepIndex}. Please confirm which School Admin you'd like to allocate
      to: <span
        style={{fontWeight: 600}}>{element.name}</span>
    </div>
    {listOfAdmins.length > 0 && <ReactDataGrid
      showColumnMenuTool={false}
      defaultSelected={listOfAdmins[0].id}
      enableSelection={true}
      onSelectionChange={selectChange}
      pagination={false}
      editable={false}
      columns={[
        {name: 'id', header: 'id', type: 'string', defaultVisible: false},
        {name: 'admin', header: 'Admin Email', type: 'string', flex: 1}
      ]}
      rowStyle={() => ({cursor: "pointer"})}
      dataSource={dataSor}
    />}
    <div className={styles.tooltipFooter}>
      <Button
          disabled={false}
          label={"Select"}
          className={styles.buttonSelect}
          onClick={() => {
            let nextStep = skipStepToStep(stepIndex);
            scrollToView(hello.current[nextStep]?.target);
            let rowVal = dataSor.filter((admin) => admin.id === selected);
            setTimeout(() => {
              if (rowVal.length > 0) updateTableDataField(rowVal[0].admin, element.rowId, element.column);
            }, 599);
            setTimeout(() => {
              setJoyDex(nextStep);
            }, 600);
          }}
      />
      <Button
          disabled={false}
          label={"Select For Remaining"}
          className={styles.buttonSelectForAll}
          onClick={() => {
            setJoyDex(hello.current.length);
            let rowVal = dataSor.filter((admin) => admin.id === selected);
            if (rowVal.length > 0) bulkUpdateAdminField(rowVal[0].admin, element.rowId);
          }}
      />
      {/*<Button*/}
      {/*    disabled={false}*/}
      {/*    label={"Skip All"}*/}
      {/*    className={styles.buttonSkipAll}*/}
      {/*    onClick={() => {*/}
      {/*      setJoyDex(hello.current.length);*/}
      {/*    }}*/}
      {/*/>*/}
      <Button
        disabled={false}
        label={"Skip Lead"}
        title={"Skip and do not invite this lead"}
        color={"green"}
        className={styles.buttonSkip}
        onClick={() => {
          updateTableDataField("No", element.rowId, "invite");
          let nextStep = skipStepToStep(stepIndex);
          setJoyDex(nextStep);
        }}
      />
    </div>
  </div>
}

const EmailValidation = (props: { stepIndex: number, element: emailChecking, fieldName: string, updateTableDataField: any, setJoyDex: any, hello: any, skipStepToStep: (stepIndex: number) => number }) => {
  const {stepIndex, element, updateTableDataField, setJoyDex, hello, skipStepToStep} = props;
  const [value, setValue] = useState<string | undefined>();
  const emailInputValidationRef: any = useRef();

  useEffect(() => {
    if (element) setValue(element.fieldValue);
  }, [element])

  useEffect(() => {
    setTimeout(() => {
      emailInputValidationRef.current.focus()
    }, 40);
  }, []);

  return <div style={{textAlign: "left"}} key={element.rowId}>
    <div style={{marginBottom: 10}}>{stepIndex}. The email <span
      style={{fontWeight: 600}}>{element?.fieldValue}</span> is not a proper email address. Please fix it.
    </div>
    <div>
      <input
        className={styles.input}
        style={{width: "-webkit-fill-available", marginTop: 20}}
        value={value || ""}
        ref={element => (emailInputValidationRef.current = element)}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !isNotEmail(value)) {
            let nextStep = skipStepToStep(stepIndex);
            scrollToView(hello.current[nextStep]?.target);

            setTimeout(() => {
              setJoyDex(nextStep);
              updateTableDataField(value, element.rowId, element.column);
            }, 600);
          }
        }}
        onChange={(e) => setValue(e.target.value)}
        autoFocus
      />

    </div>
    <div className={styles.tooltipFooter}>
      <Button
        disabled={false}
        label={"Skip Lead"}
        color={"green"}
        title={"Skip and do not invite this lead"}
        className={styles.buttonSkip}
        onClick={() => {
          updateTableDataField("No", element.rowId, "invite");
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);
          setTimeout(() => {
            setJoyDex(nextStep);
          }, 600);
        }}
      />
      <Button
        disabled={isNotEmail(value)}
        label={`Continue`}
        title={`Click or press the "Enter Key"`}
        className={styles.buttonContinue}
        onClick={() => {
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);

          setTimeout(() => {
            setJoyDex(nextStep);
            updateTableDataField(value, element.rowId, element.column);
          }, 600);
        }}
      />
    </div>
  </div>
};

const BlankNames = (props: { stepIndex: number, element: nameChecking, fieldName: string, updateTableDataField: any, setJoyDex: any, hello: any, skipStepToStep: (stepIndex: number) => number }) => {
  const {stepIndex, element, fieldName, updateTableDataField, setJoyDex, hello, skipStepToStep} = props;
  const [value, setValue] = useState<string>("");
  const blankNamesInputValidationRef: any = useRef();

  useEffect(() => {
    if (element) setValue(element.fieldValue);
  }, [element]);

  useEffect(() => {
    setTimeout(() => {
      if (blankNamesInputValidationRef.current) {
        blankNamesInputValidationRef.current.focus()
      }
    }, 40);
  }, []);

  return <div style={{textAlign: "left"}} key={element.rowId}>
    <div style={{marginBottom: 10}}>{stepIndex}. {fieldName} is missing and required. Please add it in.
    </div>
    <div>
      <input
        className={styles.input}
        style={{width: "-webkit-fill-available", marginTop: 20}}
        value={value || ""}
        ref={element => (blankNamesInputValidationRef.current = element)}
        onKeyPress={(e) => {
          if (e.key === "Enter" && value?.length !== 0 && !!value?.trim()) {
            let nextStep = skipStepToStep(stepIndex);
            scrollToView(hello.current[nextStep]?.target);
            updateTableDataField(value, element.rowId, element.column);
            setTimeout(() => {
              setJoyDex(nextStep);
            }, 1000);
          }
        }}
        onChange={(e) => setValue(e.target.value)}
        autoFocus
      />

    </div>
    <div className={styles.tooltipFooter}>
      <Button
        disabled={false}
        label={"Skip Lead"}
        color={"green"}
        title={"Skip and do not invite this lead"}
        className={styles.buttonSkip}
        onClick={() => {
          updateTableDataField("No", element.rowId, "invite");
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);
          setTimeout(() => {
            setJoyDex(nextStep);
          }, 600);
        }}
      />
      <Button
        disabled={value?.length === 0 || !value}
        label={`Continue`}
        title={`Click or press the "Enter Key"`}
        className={styles.buttonContinue}
        onClick={() => {
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);
          updateTableDataField(value, element.rowId, element.column);
          setTimeout(() => {
            setJoyDex(nextStep);
          }, 600);
        }}
      />
    </div>
  </div>
}

export const FixDataWizard = (props: Props) => {

  const {dataToClean, updateTableDataField, bulkUpdateAdminField, setTourEnd, dataSource} = props;
  const [dataCleanSteps, setDataCleanSteps] = useState<Step[]>([]);
  const [joyDex, setJoyDex] = useState<number>(0);
  const allInputRefs: any = useRef({});
  const hello: any = useRef(dataCleanSteps);
  hello.current = dataCleanSteps;

  const skipStepToStep = useCallback((currentStepIndex: number) => {
    let nextStepIndex = currentStepIndex + 1;

    for (let i = nextStepIndex; i < hello.current.length; i++) {
      if (dataSource[hello.current[i]?.rowId] && dataSource[hello.current[i]?.rowId]?.invite === "Yes") {
        nextStepIndex = i;
        break;
      } else if (i === hello.current.length - 1) {
        nextStepIndex++;
      }
    }
    return nextStepIndex;
  }, [dataSource]);

  const Tooltip: React.ElementType<TooltipRenderProps> = (props) => {
    const {
      step,
      tooltipProps,
    } = props;

    return (
      <div {...tooltipProps} className={styles.tooltipBody}>
        {step.title && <div className={styles.tooltipTitle}>{step.title}</div>}
        <div className={styles.tooltipContent}>{step.content}</div>
      </div>
    )
  };

  useEffect(() => {
    if (dataCleanSteps.length === 0) {
      let tempArr: (Step & { rowId: number, columnId: string, fieldValue: string, otherData?: any[] })[] = [];
      let stepIndex = 0;

      if (dataToClean?.checkingFirstName.length > 0) {
        for (let e = 0; e < dataToClean.checkingFirstName.length; e++) {
          let firstName = dataToClean.checkingFirstName[e];

          tempArr.push({
            content: <BlankNames stepIndex={stepIndex} element={firstName} fieldName={"First Name"}
                                 updateTableDataField={updateTableDataField} setJoyDex={setJoyDex}
                                 skipStepToStep={skipStepToStep} hello={hello}/>,
            target: `.firstName-${firstName.rowId}`,
            placement: "auto",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: firstName.rowId,
            columnId: firstName.column,
            fieldValue: firstName.fieldValue
          })
          stepIndex++;
        }
      }

      if (dataToClean?.checkingSecondName.length > 0) {
        for (let e = 0; e < dataToClean.checkingSecondName.length; e++) {
          let secondName = dataToClean.checkingSecondName[e];

          tempArr.push({
            content: <BlankNames stepIndex={stepIndex} element={secondName} fieldName={"Second Name"}
                                 updateTableDataField={updateTableDataField} setJoyDex={setJoyDex}
                                 skipStepToStep={skipStepToStep} hello={hello}/>,
            target: `.lastName-${secondName.rowId}`,
            placement: "auto",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: secondName.rowId,
            columnId: secondName.column,
            fieldValue: secondName.fieldValue
          })
          stepIndex++;
        }
      }

      if (dataToClean?.checkingEmails.length > 0) {
        for (let e = 0; e < dataToClean.checkingEmails.length; e++) {
          let email = dataToClean.checkingEmails[e];

          tempArr.push({
            content: <EmailValidation stepIndex={stepIndex} element={email} fieldName={"email"}
                                      updateTableDataField={updateTableDataField} setJoyDex={setJoyDex}
                                      skipStepToStep={skipStepToStep} hello={hello}/>,
            target: `.email-${email.rowId}`,
            placement: "auto",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: email.rowId,
            columnId: email.column,
            fieldValue: email.fieldValue
          })
          stepIndex++;
        }
      }

      if (dataToClean?.checkingAdmins.length > 0) {
        for (let a = 0; a < dataToClean.checkingAdmins.length; a++) {
          let adminEmail = dataToClean.checkingAdmins[a];

          tempArr.push({
            content: <AdminEmailValidation stepIndex={stepIndex} element={adminEmail}
                                           updateTableDataField={updateTableDataField}
                                           bulkUpdateAdminField={bulkUpdateAdminField}
                                           setJoyDex={setJoyDex} skipStepToStep={skipStepToStep} hello={hello}/>,
            target: `.adminEmail-${adminEmail.rowId}`,
            placement: "auto",
            isFixed: true,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: adminEmail.rowId,
            columnId: adminEmail.column,
            // @ts-ignore
            fieldValue: adminEmail.fieldValue
          })
          stepIndex++;
        }
      }
      setDataCleanSteps(tempArr);
    }

  }, [dataToClean, dataCleanSteps.length, updateTableDataField, skipStepToStep, bulkUpdateAdminField])

  return (
    <Joyride
      tooltipComponent={Tooltip}
      run={dataCleanSteps?.length >= 1}
      stepIndex={joyDex}
      continuous={true}
      disableOverlay={false}
      disableCloseOnEsc={true}
      callback={(tour) => {
        setTimeout(() => {
          if (allInputRefs.current[tour.index]) allInputRefs.current[tour.index].focus();
        }, 300);
        if (tour.type === EVENTS.TOUR_END) {
          setTourEnd(false);
        }
      }}
      steps={dataCleanSteps}
      styles={{
        options: {
          primaryColor: '#FFB073',
          textColor: 'rgb(39, 70, 73)'
        }
      }}
    />
  );
}


// const enterPress = useKeyPress("Enter");

// // @ts-ignore
// function useKeyPress(targetKey) {
//     // State for keeping track of whether key is pressed
//     const [keyPressed, setKeyPressed] = useState<boolean>(false);
//     // If pressed key is our target key then set to true
//     // @ts-ignore
//     function downHandler({key}) {
//         if (key === targetKey) {
//             setKeyPressed(true);
//         }
//     }
//
//     // Add event listeners
//     useEffect(() => {
//         window.addEventListener("keypress", downHandler);
//         // Remove event listeners on cleanup
//         return () => {
//             window.removeEventListener("keypress", downHandler);
//         };
//     }, []); // Empty array ensures that effect is only run on mount and unmount
//     return keyPressed;
// }

// type step = { content: JSX.Element, target: string; placement: string; hideCloseButton: boolean; disableOverlayClose: boolean; disableBeacon: boolean; disableOverlay: boolean, rowId?: number, columnId?: string, fieldValue?: string, dex: number }


// const listen = (e: any) => {
//     logger.info(e.key)
//     if (e.key === "Enter") {
//         let rowVal = dataSor.filter((admin) => admin.id === selected);
//         setJoyDex(stepIndex + 1);
//         if (rowVal.length > 0) updateTableDataField(rowVal[0].admin, element.rowId, element.column);
//     }
// }
//
// useEffect(() => {
//     document.addEventListener('keypress', listen);
//     // return (() => {
//     //     document.removeEventListener('keypress', listen);
//     // })
// }, []);

// const initialStep: step = {
//     content: (
//         <div style={{textAlign: "left"}}>
//             <div style={{marginBottom: 10}}>We have found issues with your data.</div>
//             <div style={{marginBottom: 10}}>We will now guide you through fixing it.</div>
//         </div>
//     ),
//     target: `#data-cleaning`,
//     placement: "left",
//     hideCloseButton: true,
//     disableOverlayClose: true,
//     disableBeacon: true,
//     disableOverlay: false,
//     dex: 0
// }

// const columnsAccount = [
//     {name: 'id', header: 'id', type: 'number', width: 30, headerEllipsis: false},
//     // { name: 'number', header: 'Num', defaultWidth: 60, type: 'number' },
//     {name: "account", header: 'Account', flex: 1},
//     {name: 'match', header: '% Match', width: 80, headerEllipsis: false},
// ]
// const columnsSchool = [
//     {name: 'id', header: 'id', type: 'number', width: 30, headerEllipsis: false},
//     // { name: 'number', header: 'Num', defaultWidth: 60, type: 'number' },
//     {name: "school", header: 'School', flex: 1},
//     {name: 'match', header: '% Match', width: 80, headerEllipsis: false},
// ]

// if (dataToClean?.checkingAccounts.length > 0 && Object.keys(allInputRefs).length > 0) {
//     for (let a = 0; a < dataToClean.checkingAccounts.length; a++) {
//         let account = dataToClean.checkingAccounts[a];
//
//         tempArr.push({
//             content: showListSimilarNames(stepIndex, account, "account", dataToClean.checkingAccounts[a + 1]),
//             target: `.account-${account.rowId}`,
//             placement: "auto",
//             hideCloseButton: true,
//             disableOverlayClose: true,
//             disableBeacon: true,
//             rowId: account.rowId,
//             columnId: account.column,
//             fieldValue: account.fieldValue
//         })
//         stepIndex++;
//     }
// }
//
// if (dataToClean?.checkingSchools.length > 0 && Object.keys(allInputRefs).length > 0) {
//     for (let s = 0; s < dataToClean.checkingSchools.length; s++) {
//         let school = dataToClean.checkingSchools[s];
//
//         tempArr.push({
//             content: showListSimilarNames(stepIndex, school, "school", dataToClean.checkingSchools[s + 1]),
//             target: `.school-${school.rowId}`,
//             placement: "auto",
//             disableBeacon: true,
//             hideCloseButton: true,
//             disableOverlayClose: true,
//             rowId: school.rowId,
//             columnId: school.column,
//             fieldValue: school.fieldValue
//         })
//         stepIndex++;
//     }
// }

// const showListSimilarNames = (stepIndex: number, element: typoCheckings, fieldName: string, nextID?: any | undefined) => {
//     return <div style={{textAlign: "left"}} key={element.rowId}>
//         <div style={{marginBottom: 10}}>{stepIndex}. We found a few Open Parachute {fieldName}s with similar names
//             to <span style={{fontWeight: 600}}>{element?.fieldValue}</span>. Please confirm which one you were
//             referring to:
//         </div>
//         <div>
//             <ReactDataGrid
//                 pagination={false}
//                 editable={false}
//                 showColumnMenuTool={false}
//                 columns={fieldName === 'account' ? columnsAccount : columnsSchool}
//                 rowStyle={() => ({cursor: "pointer"})}
//                 onRowClick={(rowProps, event) => {
//                     allInputRefs.current[stepIndex].value = rowProps.data[fieldName];
//                 }}
//                 dataSource={element.arrayForCheck.sort((a, b) =>
//                     parseFloat(String(b.rating)) - parseFloat(String(a.rating))).map((word: Rating, dexy: number) => {
//                     let ret: { [id: string]: string | number } = {
//                         id: dexy,
//                         match: `${Math.round(word.rating * 100)}%`
//                     }
//                     ret[fieldName] = word.target;
//                     return ret
//                 })}
//             />
//             <input className={styles.input}
//                    style={{width: "100%", marginTop: 20}}
//                    defaultValue={element?.fieldValue}
//                    autoFocus
//                    ref={element => (allInputRefs.current[stepIndex] = element)}
//             />
//
//         </div>
//         <div className={styles.tooltipFooter}>
//             {/*<Button color="green" className={styles.buttonChangeAll} label={"Change All"} onClick={() => {*/}
//             {/*    let which: any[] = [];*/}
//             {/*    if (fieldName === "account") which = dataToClean.checkingAccounts;*/}
//             {/*    else if (fieldName === "school") which = dataToClean.checkingSchools;*/}
//             {/*    else if (fieldName === "email") which = dataToClean.checkingEmails*/}
//
//             {/*    let skipSteps = [];*/}
//
//             {/*    for (let i = 0; i < which.length; i++) {*/}
//             {/*        logger.info(which[i])*/}
//             {/*        logger.info(dataToClean)*/}
//             {/*        logger.info(element)*/}
//             {/*        logger.info(dataCleanSteps)*/}
//             {/*        logger.info(moreRowCheckings)*/}
//             {/*        // @ts-ignore*/}
//             {/*        logger.info(refersdataCleanSteps.current)*/}
//             {/*        logger.info(stepIndex)*/}
//             {/*        if (which[i].fieldValue === element?.fieldValue) {*/}
//             {/*            // skipSteps.push()*/}
//             {/*            // updateTableDataField(allInputRefs.current[stepIndex].value, which[i].row, which[i].column);*/}
//             {/*            // setSkipSteps((prevState => prevState.push(which[i].dex)))*/}
//             {/*        }*/}
//             {/*    }*/}
//             {/*}}/>*/}
//             <Button
//                 label={"Continue"}
//                 className={styles.buttonContinue}
//                 onClick={() => {
//                     // custom scroll into view fn
//                     if (nextID) {
//                         document.getElementsByClassName(`${nextID.column}-${nextID.rowId}`)[0]?.scrollIntoView({block: "center"});
//                     }
//                     updateTableDataField(allInputRefs.current[stepIndex].value, element.rowId, element.column);
//
//                     setTimeout(() => {
//                         setJoyDex(stepIndex + 1);
//                     }, 600);
//                 }}
//             />
//         </div>
//     </div>
// }


// 0:
// account: "Jesuit Schools Sydney"
// adminEmail: "rob.hub@gmail.com"
// email: "bob+rob.hub@gmail.com"
// firstName: "Bob"
// id: 0
// lastName: "Hubs"
// role: "Teacher"
// school: "Corpus Christi"


// <ReactDataGrid
//     onReady={(gridData) => {
//         // setGridRef(gridData);
//     }}
//     pagination={false}
//     style={gridStyle}
//     editable={false}
//     columns={columnsTw}
//     dataSource={dataSource}
// />

//
//     <div style={{backgroundColor:"lightgray", padding:10, borderRadius:4}}>
// {school.schoolsToCheck.map((word, nestedDex) => (
//     <div
//         style={{cursor: "pointer"}}
//         onClick={() => {
//             allInputRefs.current[dex].value = word.target;
//             let newArr = [...allElements];
//             newArr[dex].updated = word.target;
//             setAllElements(newArr);
//         }}>
//         {nestedDex}. {word.target} <span style={{fontWeight:600}}>({Math.round(word.rating * 100)}% match)</span>
//     </div>
// ))}
// </div>


//     <div style={{backgroundColor: "lightgray", padding: 10, borderRadius: 4}}>
//
// {account.accountsToCheck.map((word, nestedDex) => (
//     <div
//         style={{cursor: "pointer"}}
//         onClick={() => {
//             allInputRefs.current[dex].value = word.target;
//             let newArr = [...allElements];
//             newArr[dex].updated = word.target;
//             setAllElements(newArr);
//         }}>
//         {nestedDex}. {word.target} <span style={{fontWeight:600}}>({Math.round(word.rating * 100)}% match)</span>
//     </div>
// ))
// }
// </div>


// setElementsRefSchools({
//     ...elementsRefSchools,
//     [nestedDex]: {
//         ...elementsRefSchools[nestedDex],
//         updatedSchool: word.target,
//     },
// });

// setElementsRefSchools({...elementsRefSchools, [dex]: elementsRefSchools[dex], updatedSchool: word.target})
// setElementsRefSchools({...elementsRefSchools, [dex]: word.target})

// [
//     {
//         content:
//             "Double click or press enter on this cell to open the DropDownEditor",
//         target: "#school-0"
//     },
//     {
//         content: (
//             <>
//                 <h5 style={{ marginTop: 0 }}>Weekly magic on your inbox</h5>
//                 <div>
//                     <input type="email" placeholder="Type your email" />
//                     <button>SEND</button>
//                 </div>
//             </>
//         ),
//         target: "#school-2"
//     }
// ]
// ref={element => (abcSchools.current[dex] = element)}
// {/*/!*{index > 0 && (*!/*/
// }
// {/*/!*    <button {...backProps}>*!/*/
// }
// {/*/!*        <div id="back">Back</div>*!/*/
// }
// {/*/!*    </button>*!/*/
// }
// {/*/!*)}*!/*/
// }
// {/*                /!*{continuous && (*!/*/
// }
// {/*                /!*    <button {...primaryProps}>*!/*/
// }
// {/*                /!*        <div id="next">Next</div>*!/*/
// }
// {/*                /!*    </button>*!/*/
// }
// {/*                /!*)}*!/*/
// }
// {/*                /!*{!continuous && (*!/*/
// }
// {/*                /!*    <button {...closeProps}>*!/*/
// }
// {/*                /!*        <div id="close">Close</div>*!/*/
// }
// {/*                /!*    </button>*!/*/
// }
// {/*                /!*)}*!/*/
// }
// {/*            </div>*/
// }
